import Header from "@/components/Header";
import Footer from "@/components/Footer";
import PricingSection from "@/components/PricingSection";

const PricingPage = () => {
  return (
    <div className="min-h-screen bg-stone-50" data-testid="pricing-page">
      <Header />
      <main className="pt-20">
        <PricingSection />
      </main>
      <Footer />
    </div>
  );
};

export default PricingPage;
